/**
 * Help Centre FAQs shown on /tutorials.
 * Only entries for routes any visitor can use (public in featureAccess.js).
 */

/** @typedef {'public'} HelpFaqAccess */

/** @type {{ id: string, access: HelpFaqAccess }[]} */
export const HELP_FAQ_ITEMS = [
  { id: 'whatIsEdvise', access: 'public' },
  { id: 'howDoIUseJupas', access: 'public' },
  { id: 'howAccurateAreRecommendations', access: 'public' },
  { id: 'whatInformationDoINeed', access: 'public' },
  { id: 'doINeedAnAccount', access: 'public' },
  { id: 'isMyDataSecure', access: 'public' },
  { id: 'howCanIGetSupport', access: 'public' }
];

export function getPublicHelpFaqIds() {
  return HELP_FAQ_ITEMS.filter((item) => item.access === 'public').map((item) => item.id);
}
